import { translation as translateMessage } from '../../../_helpers/Translate'

export function translation(id) {
  return translateMessage(id)
}
